<template>
  <template v-for="(menu, index) in menus" :key="index">
    <template v-if="!menu.hidden">
      <template v-if="menu.children && menu.children.length > 0 && !menu.hideChildrenInMenu">
        <a-sub-menu :key="menu.path">
          <template v-if="menu.meta.icon" #icon>
            <component :is="$antIcons[menu.meta.icon]"/>
          </template>
          <template #title>
            <span>{{ menu.meta.title }}</span>
          </template>
          <side-menu :menus="menu.children"/>
        </a-sub-menu>
      </template>
      <template v-else>
        <a-menu-item :key="menu.path">
          <template v-if="menu.meta.icon" #icon>
            <component :is="$antIcons[menu.meta.icon]"/>
          </template>
          <span>{{ menu.meta.title }}</span>
        </a-menu-item>
      </template>
    </template>
  </template>
</template>

<script>

export default {
  name: 'SideMenu',
  props: {
    // mode: {
    //   type: String,
    //   required: false,
    //   default: 'inline'
    // },
    // theme: {
    //   type: String,
    //   required: false,
    //   default: 'dark'
    // },
    // collapsible: {
    //   type: Boolean,
    //   required: false,
    //   default: false
    // },
    // collapsed: {
    //   type: Boolean,
    //   required: false,
    //   default: false
    // },
    menus: {
      type: Array,
      required: true
    },
  },
  methods: {}
};
</script>

<style lang="less" scoped>

</style>
